import { render, staticRenderFns } from "./departmentSelect.vue?vue&type=template&id=88d0b76c&scoped=true&"
import script from "./departmentSelect.vue?vue&type=script&lang=js&"
export * from "./departmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d0b76c",
  null
  
)

export default component.exports